<template>
    <rkm-area
        no-margin-top
        title="Feridas"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.feridas.ferida"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.data"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.tipoDescricao"
                                    label="Tipo de ferida"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.localAnatomicoDescricao"
                                    label="Local anatômico"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.localAnatomicoRegiaoDescricao"
                                    label="Local anatômico região"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.comprimento"
                                    label="Comprimento (cm)"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.largura"
                                    label="Largura (cm)"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.profundidade"
                                    label="Profundidade (cm)"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => (item.cicatrizada ? 'Cicatrizada' : 'Ativa')"
                                    label="Status"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.procedimentos.map(p => p.procedimento?.codigo).join(', ')"
                                    label="Procedimento"
                                />
                            </rkm-col>

                            <rkm-col cols="9">
                                <Item
                                    label="Imagem da ferida"
                                    :get-value="() => ''"
                                >
                                    <div style="display: flex; gap: 6px; flex-wrap: wrap;">
                                        <img
                                            v-for="(img, index) in item.images"
                                            :key="index"
                                            :src="img.arquivo"
                                            width="40"
                                            height="40"
                                            style="object-fit: cover; border-radius: 6px;"
                                        />
                                    </div>
                                </Item>
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>